/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { MerchantCategory } from '../model/merchantCategory';
import { MerchantCategoryCreateInput } from '../model/merchantCategoryCreateInput';
import { MerchantCategoryList } from '../model/merchantCategoryList';
import { MerchantCategoryUpdateInput } from '../model/merchantCategoryUpdateInput';
import { Model23 } from '../model/model23';
import { Model77 } from '../model/model77';
import { Model78 } from '../model/model78';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MerchantCategoryService {

    protected basePath = 'http://localhost:5001';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a MerchantCategory
     * 
     * @param orgName 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgsOrgnameMerchantcategoryId(orgName: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteOrgsOrgnameMerchantcategoryId(orgName: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteOrgsOrgnameMerchantcategoryId(orgName: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteOrgsOrgnameMerchantcategoryId(orgName: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling deleteOrgsOrgnameMerchantcategoryId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrgsOrgnameMerchantcategoryId.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all MerchantCategory(s)
     * 
     * @param orgName 
     * @param populate 
     * @param archived 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param offset 
     * @param page 
     * @param limit 
     * @param sortBy 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameMerchantcategory(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<MerchantCategoryList>;
    public getOrgsOrgnameMerchantcategory(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantCategoryList>>;
    public getOrgsOrgnameMerchantcategory(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantCategoryList>>;
    public getOrgsOrgnameMerchantcategory(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameMerchantcategory.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (archived !== undefined && archived !== null) {
            queryParameters = queryParameters.set('archived', <any>archived);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MerchantCategoryList>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the count of all MerchantCategory(s)
     * 
     * @param orgName 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameMerchantcategoryCount(orgName: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<Model23>;
    public getOrgsOrgnameMerchantcategoryCount(orgName: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model23>>;
    public getOrgsOrgnameMerchantcategoryCount(orgName: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model23>>;
    public getOrgsOrgnameMerchantcategoryCount(orgName: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameMerchantcategoryCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Model23>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MerchantCategory
     * 
     * @param orgName 
     * @param id 
     * @param populate 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameMerchantcategoryId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<MerchantCategory>;
    public getOrgsOrgnameMerchantcategoryId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantCategory>>;
    public getOrgsOrgnameMerchantcategoryId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantCategory>>;
    public getOrgsOrgnameMerchantcategoryId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameMerchantcategoryId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameMerchantcategoryId.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MerchantCategory>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MerchantCategory field
     * 
     * @param orgName 
     * @param id 
     * @param fieldName 
     * @param populate 
     * @param q 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameMerchantcategoryIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getOrgsOrgnameMerchantcategoryIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getOrgsOrgnameMerchantcategoryIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getOrgsOrgnameMerchantcategoryIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameMerchantcategoryIdFieldname.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameMerchantcategoryIdFieldname.');
        }

        if (fieldName === null || fieldName === undefined) {
            throw new Error('Required parameter fieldName was null or undefined when calling getOrgsOrgnameMerchantcategoryIdFieldname.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any>q);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/${encodeURIComponent(String(id))}/${encodeURIComponent(String(fieldName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a MerchantCategory
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameMerchantcategory(orgName: string, body?: MerchantCategoryCreateInput, observe?: 'body', reportProgress?: boolean): Observable<MerchantCategory>;
    public postOrgsOrgnameMerchantcategory(orgName: string, body?: MerchantCategoryCreateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantCategory>>;
    public postOrgsOrgnameMerchantcategory(orgName: string, body?: MerchantCategoryCreateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantCategory>>;
    public postOrgsOrgnameMerchantcategory(orgName: string, body?: MerchantCategoryCreateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameMerchantcategory.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MerchantCategory>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import multiple MerchantCategory
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameMerchantcategoryImport(orgName: string, body?: Model77, observe?: 'body', reportProgress?: boolean): Observable<Model78>;
    public postOrgsOrgnameMerchantcategoryImport(orgName: string, body?: Model77, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model78>>;
    public postOrgsOrgnameMerchantcategoryImport(orgName: string, body?: Model77, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model78>>;
    public postOrgsOrgnameMerchantcategoryImport(orgName: string, body?: Model77, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameMerchantcategoryImport.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Model78>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/import`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a MerchantCategory
     * 
     * @param orgName 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameMerchantcategoryId(orgName: string, id: string, body?: MerchantCategoryUpdateInput, observe?: 'body', reportProgress?: boolean): Observable<MerchantCategory>;
    public putOrgsOrgnameMerchantcategoryId(orgName: string, id: string, body?: MerchantCategoryUpdateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantCategory>>;
    public putOrgsOrgnameMerchantcategoryId(orgName: string, id: string, body?: MerchantCategoryUpdateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantCategory>>;
    public putOrgsOrgnameMerchantcategoryId(orgName: string, id: string, body?: MerchantCategoryUpdateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameMerchantcategoryId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameMerchantcategoryId.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<MerchantCategory>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/${encodeURIComponent(String(id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Publish a MerchantCategory
     * 
     * @param orgName 
     * @param id 
     * @param published 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameMerchantcategoryIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'body', reportProgress?: boolean): Observable<MerchantCategory>;
    public putOrgsOrgnameMerchantcategoryIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantCategory>>;
    public putOrgsOrgnameMerchantcategoryIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantCategory>>;
    public putOrgsOrgnameMerchantcategoryIdPublishedPublished(orgName: string, id: string, published: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameMerchantcategoryIdPublishedPublished.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameMerchantcategoryIdPublishedPublished.');
        }

        if (published === null || published === undefined) {
            throw new Error('Required parameter published was null or undefined when calling putOrgsOrgnameMerchantcategoryIdPublishedPublished.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<MerchantCategory>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/MerchantCategory/${encodeURIComponent(String(id))}/published/${encodeURIComponent(String(published))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
